import React, {useRef, useState} from "react";
import styles from "./HierarchyContextTransition.module.css";
import {ChatHistoryDTO} from "../../../../../../../api/generated";
import {Arrow} from "../../../../../../elements/arrow/Arrow";
import {HierarchyContextValue} from "./HierarchyContextValue";

interface HierarchyContextTransitionProps {
    chatHistory: ChatHistoryDTO
}

export const HierarchyContextTransition: React.FC<HierarchyContextTransitionProps> = ({chatHistory}) => {
    const [isOpen, setIsOpen] = useState(false);
    const detailsContentRef = useRef<HTMLDivElement>(null);

    return <div className={styles.wrapper}>
        <div className={styles.preview}>
            <div className={styles.line}/>
            <div
                className={styles.content}
                onClick={() => setIsOpen(prev => !prev)}
            >
                <img className={styles.icon} src={"/toolCallIcon.svg"} alt="Context Change"/>
                <span className={styles.text}>context changed</span>
                <Arrow isUp={isOpen} onClick={() => setIsOpen(prev => !prev)}/>
            </div>
            <div className={styles.line}/>
        </div>
        <div
            className={`${styles.details} ${isOpen ? styles.detailsOpen : ""}`}
            style={{maxHeight: isOpen ? `${detailsContentRef.current?.scrollHeight || 0}px` : 0}}
        >
            <div className={styles.detailsContent} ref={detailsContentRef}>
                {chatHistory.activeFranchiseContextSource && <div className={styles.detailRow}>
                    <span className={styles.detailLabel}>Franchise</span>
                    <span className={styles.detailValue}>
                        <HierarchyContextValue
                            publicId={chatHistory.activeFranchisePublicId}
                            source={chatHistory.activeFranchiseContextSource}
                            pathPrefix="/franchises"
                        />
                    </span>
                </div>}
                {chatHistory.activeLocationContextSource && <div className={styles.detailRow}>
                    <span className={styles.detailLabel}>Location</span>
                    <span className={styles.detailValue}>
                        <HierarchyContextValue
                            publicId={chatHistory.activeLocationPublicId}
                            source={chatHistory.activeLocationContextSource}
                            pathPrefix="/locations"
                        />
                    </span>
                </div>}
            </div>
        </div>
    </div>
}
